module.exports = __webpack_public_path__ + "static/media/login-bg.f6c0f3e6.jpg";